import { History, Loader2 } from 'lucide-react';
import { VoiceCallHistory } from '../components/teamChat/VoiceCallHistory';
import { useI18n } from '../contexts/I18nContext';
import { useVoiceCalls } from '../hooks/useVoiceCalls';

/**
 * /team-chat/calls — every call the company had, newest first, across all
 * voice channels (including channels since deleted: the call keeps the name).
 * The row opens the call page with its transcript.
 */
export function VoiceCallsPage() {
  const { t } = useI18n();
  const { data, isLoading } = useVoiceCalls({ limit: 100 });

  return (
    <div className="flex h-full min-h-0 flex-col">
      <header className="flex items-center gap-2 border-b border-border px-4 py-2.5">
        <History size={18} className="shrink-0 text-muted-foreground" />
        <div className="min-w-0 flex-1">
          <h1 className="truncate font-heading text-base font-semibold text-foreground">
            {t('teamChat.voiceCallHistory')}
          </h1>
          <p className="text-xs text-muted-foreground">
            {data?.transcriptionEnabled
              ? t('teamChat.voiceTranscriptHint')
              : t('teamChat.voiceTranscriptOff')}
          </p>
        </div>
      </header>

      <div className="min-h-0 flex-1 overflow-y-auto px-4 py-4">
        {isLoading ? (
          <p className="flex items-center gap-2 text-sm text-muted-foreground">
            <Loader2 size={14} className="animate-spin" />
            {t('common.loading')}
          </p>
        ) : (
          <VoiceCallHistory
            calls={data?.calls ?? []}
            showChannel
            emptyText={t('teamChat.voiceNoCalls')}
          />
        )}
      </div>
    </div>
  );
}
